module.exports = __webpack_public_path__ + "img/artplace.78fea5ed.png";